import { supabase } from '../../../../supabase';

export const fetchStadiumRankings = async (category) => {
  try {
    if (category === 'matches') {
      const { data, error } = await supabase
        .from('stadium24')
        .select('id, name, match_all')
        .order('match_all', { ascending: false })
        .limit(10);

      if (error) throw error;
      return data.map(stadium => ({
        ...stadium,
        value: stadium.match_all,
        unit: '경기'
      }));
    } else {
      const rateColumn = {
        'reviews': 'satisfaction',
        'grass': 'rate_grass',
        'restroom': 'rate_restroom',
        'parking': 'rate_parking',
        'waiting': 'rate_waiting',
        'access': 'rate_access',
        'shower': 'rate_shower',
        'info': 'rate_info'
      }[category];

      const reviewColumns = {
        'reviews': 'review_cnt',
        'grass': 'good_grass, bad_grass',
        'restroom': 'good_restroom, bad_restroom',
        'parking': 'good_parking, bad_parking',
        'waiting': 'good_waiting, bad_waiting',
        'access': 'good_access, bad_access',
        'shower': 'good_shower, bad_shower',
        'info': 'good_info, bad_info'
      }[category];

      let query = supabase
        .from('stadium24_review')
        .select(`
          stadium24_id,
          stadium24 (
            id,
            name
          ),
          ${rateColumn},
          ${reviewColumns},
          is_rental,
          is_laundry
        `)
        .gte('review_cnt', 100)
        .order(rateColumn, { ascending: false });

      // 카테고리별 정렬 조건 추가
      if (category === 'reviews') {
        query = query.order('review_cnt', { ascending: false });
      } else {
        query = query.order(`good_${category}`, { ascending: false })
                    .order(`bad_${category}`, { ascending: false });
      }

      const { data, error } = await query.limit(10);

      if (error) throw error;

      return data.map(review => {
        let reviewCount;
        
        if (category === 'reviews') {
          reviewCount = review.review_cnt;
        } else {
          const goodKey = `good_${category}`;
          const badKey = `bad_${category}`;
          reviewCount = (review[goodKey] || 0) + (review[badKey] || 0);
        }

        return {
          id: review.stadium24.id,
          name: review.stadium24.name,
          value: review[rateColumn],
          reviewCount,
          unit: '%',
          isRental: review.is_rental,
          isLaundry: review.is_laundry
        };
      });
    }
  } catch (error) {
    console.error(`Error fetching ${category} rankings:`, error);
    return [];
  }
}; 